import { AIChipIcon } from './AnimationAtoms/AIChipIcon';
import { AIIconStack } from './AnimationAtoms/AIIconStack';
import { CustomerIconStack } from './AnimationAtoms/CustomerIconStack';
import { DataWarehouseIconStack } from './AnimationAtoms/DataWarehouseIconStack';
import { EngagementPlatformIconStack } from './AnimationAtoms/EngagementPlatformIconStack';
import { LightBulbIcon } from './AnimationAtoms/LightBulbIcon';
import { MarketingIconStack } from './AnimationAtoms/MarketingIconStack';
import { MegaphoneIcon } from './AnimationAtoms/MegaphoneIcon';
import { UserBigIcon } from './AnimationAtoms/UserBigIcon';

export const avatarPillLabels = [
  'Consent & preferences',
  'Jurisdictional regulation',
  'Data subject requests',
  'Business policy',
];

export const initiativeItems = [
  {
    text: 'AI initiatives',
    icon: <LightBulbIcon className="size-14" />,
  },
  {
    text: 'Product recommendation engines',
    icon: <MegaphoneIcon className="size-14" />,
  },
  {
    text: 'Agentic decision making',
    icon: <AIChipIcon className="size-15" />,
  },
  {
    text: '1st party data personalization',
    icon: <UserBigIcon className="size-13" />,
  },
];

export const cardIconBlocks = {
  customerIdentity: {
    text: 'Customer identity & access management tools',
    iconStack: <CustomerIconStack height="34" />,
    iconBlockId: 'cardBorder1',
  },
  ai: {
    text: 'AI data pipelines',
    iconStack: <AIIconStack height="34" />,
    iconBlockId: 'cardBorder1',
  },
  engagementPlatforms: {
    text: 'Customer engagement platforms',
    iconStack: <EngagementPlatformIconStack height="34" />,
    iconBlockId: 'cardBorder4',
  },
  marketingAdTech: {
    text: 'Marketing & ad tech stack',
    iconStack: <MarketingIconStack height="34" />,
    iconBlockId: 'cardBorder3',
  },
  dataWarehouses: {
    text: 'Data warehouses',
    iconStack: <DataWarehouseIconStack height="34" />,
    iconBlockId: 'cardBorder2',
  },
};
